/** Describes skeleton row ranges before/after the buffered data within a viewport */
export type SkeletonRanges = {
  /** Skeleton rows before the buffered data: [startIndex, endIndex) */
  before: { start: number; count: number };
  /** Skeleton rows after the buffered data: [startIndex, endIndex) */
  after: { start: number; count: number };
};

/**
 * Compute skeleton (placeholder) ranges for a viewport range given a buffer position.
 * Returns the ranges of rows that fall outside the buffer and need skeleton rendering.
 */
export function computeSkeletonRanges(
  viewStart: number,
  viewEnd: number,
  bufferStartOffset: number,
  bufferRowCount: number,
): SkeletonRanges {
  const bufEnd = bufferStartOffset + bufferRowCount;

  if (bufferRowCount === 0) {
    return {
      before: { start: viewStart, count: viewEnd - viewStart },
      after: { start: 0, count: 0 },
    };
  }

  const beforeCount = Math.max(0, Math.min(viewEnd, bufferStartOffset) - viewStart);
  const afterStart = Math.max(viewStart, bufEnd);
  const afterCount = Math.max(0, viewEnd - afterStart);

  return {
    before: { start: viewStart, count: beforeCount },
    after: { start: afterStart, count: afterCount },
  };
}
